__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.6.0", () => (() => (__webpack_require__(8284))), 1);
			register("@emotion/styled", "11.6.0", () => (() => (__webpack_require__(932))), 1);
			register("@mui/material", "5.4.1", () => (() => (__webpack_require__(2361))), 1);
			register("@reduxjs/toolkit", "1.7.1", () => (() => (__webpack_require__(9829))), 1);
			register("prop-types", "15.7.2", () => (() => (__webpack_require__(5697))), 1);
			register("prop-types", "15.8.1", () => (() => (__webpack_require__(4627))), 1);
			register("prop-types", "15.8.1", () => (() => (__webpack_require__(8260))), 1);
			register("prop-types", "15.8.1", () => (() => (__webpack_require__(6277))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(3935))), 1);
			register("react-redux", "7.2.5", () => (() => (__webpack_require__(8216))), 1);
			register("react-router-dom", "5.3.0", () => (() => (__webpack_require__(3727))), 1);
			register("react-router", "5.2.1", () => (() => (__webpack_require__(5977))), 1);
			register("react-transition-group", "4.4.1", () => (() => (__webpack_require__(5128))), 1);
			register("react-transition-group", "4.4.5", () => (() => (__webpack_require__(5941))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(7294))), 1);
			register("redux-persist", "6.0.0", () => (() => (__webpack_require__(2042))), 1);
			register("redux-thunk", "2.4.2", () => (() => (__webpack_require__(5139))), 1);
			register("redux", "4.1.1", () => (() => (__webpack_require__(4890))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(3105))), 1);
			initExternal(9657);
			initExternal(9679);
			initExternal(2935);
			initExternal(6879);
			initExternal(7856);
			initExternal(2721);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};